import gsap from 'gsap';

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { isMobile } from '../_app/cuchillo/core/Basics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

export class ScrollItem__ProjectList extends ScrollItem__BlockDefault {
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    setAnimations() {
        super.setAnimations();

        if (!isMobile) {
            // console.log(Maths.maxminRandom(4, 1));

            this.item.style.setProperty("--column", Maths.maxminRandom(4, 1));
        }
    }
}

Scroll._registerClass('ProjectList', ScrollItem__ProjectList);
